import { render, staticRenderFns } from "./ZyroSegmentControl.vue?vue&type=template&id=1b839165&scoped=true&"
import script from "./ZyroSegmentControl.vue?vue&type=script&lang=js&"
export * from "./ZyroSegmentControl.vue?vue&type=script&lang=js&"
import style0 from "./ZyroSegmentControl.vue?vue&type=style&index=0&id=1b839165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b839165",
  null
  
)

export default component.exports